"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgClose = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.SvgClose = () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M19.375 3.30344L16.6966 0.625L10 7.32156L3.30344 0.625L0.625 3.30344L7.32156 10L0.625 16.6966L3.30344 19.375L10 12.6784L16.6966 19.375L19.375 16.6966L12.6784 10L19.375 3.30344Z", fill: "black" })));
//# sourceMappingURL=SvgClose.js.map